module.exports = __webpack_public_path__ + "img/imweb_design_3.c0c8d9ef.png";